import QRCode from "qrcode-generator"
import { BadgeQRFormat } from "sharedTypes/badge"
import { QR_MOCK_DATA } from "./sampleData"

/**
 * Generate SVG path data for a QR code based on format
 * Returns a path string that can be used in an SVG <path> element
 *
 * @param format - The QR code format (GUEST_ID or VCARD)
 * @returns SVG path data string
 */
export const generateQRCodePath = (format: BadgeQRFormat): string => {
  try {
    const data = QR_MOCK_DATA[format]

    // Create QR code with auto version selection and M error correction
    // Version 0 = auto-detect optimal version based on data length
    const qr = QRCode(0, "M")
    qr.addData(data)
    qr.make()

    const moduleCount = qr.getModuleCount()
    // Normalize to 100x100 viewBox for easier scaling
    const cellSize = 100 / moduleCount

    // Build path segments for all dark modules
    const segments: string[] = []
    for (let row = 0; row < moduleCount; row += 1) {
      for (let col = 0; col < moduleCount; col += 1) {
        if (qr.isDark(row, col)) {
          const x = col * cellSize
          const y = row * cellSize
          // Create a square path for each dark module
          segments.push(`M${x},${y}h${cellSize}v${cellSize}h-${cellSize}z`)
        }
      }
    }

    return segments.join(" ")
  } catch (error) {
    return ""
  }
}

export default generateQRCodePath
